import styled from 'styled-components'
import { getDashColor } from '../../styles'
import {
  PRIMARY_BLUE_02,
  PRIMARY_RED_01,
  GRAY_SCALE_04,
  GRAY_SCALE_09,
  PRIMARY_RED_10,
  SECONDARY_BLUE_10,
  SECONDARY_GREEN_07,
  SECONDARY_GREEN_10,
  SECONDARY_YELLOW_05,
  SECONDARY_YELLOW_10,
  WHITE,
} from 'bd-web-components/src/utils/dash-colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`

export const FormDivider = styled.div`
  background-color: ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 8px;
`

export const PageSubtitle = styled.p`
  color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  opacity: 0.6;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-weight: 400;
  }
`

export const PageTitle = styled.h4`
  color: ${getDashColor('PRIMARY_BLUE_02', 'GRAY_DARK')};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-weight: 600;
    line-height: 22px;
    margin-bottom: 13px;
  }
`

export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
    margin-top: 25px;
  }
`

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const PageOptions = styled.h5`
  color: ${PRIMARY_BLUE_02};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px;
  margin-top: 32px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 13px;
  }
`

export const SectionHeaderRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  margin-top: 32px;
  margin-bottom: 24px;

  ${PageOptions} {
    margin: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 13px;
  }
`

export const SectionDescription = styled.p`
  color: ${GRAY_SCALE_04};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: -12px 0 16px;
  max-width: 760px;
`

export const QuestionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 5px;
  padding: 24px;
  background: ${WHITE};

  @media (max-width: 768px) {
    padding: 16px;
  }
`

export const QuestionSummary = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const QuestionSummaryText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`

export const QuestionTitle = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  word-break: break-word;
`

export const OptionResultsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
`

export const OptionResultItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const OptionResultHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-size: 14px;
  line-height: 20px;
`

export const OptionResultLabel = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-weight: 500;
  word-break: break-word;
`

export const OptionResultValue = styled.span`
  color: ${GRAY_SCALE_04};
  font-weight: 600;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
`

export const OptionResultBar = styled.div`
  height: 8px;
  border-radius: 100px;
  background: ${GRAY_SCALE_09};
  overflow: hidden;
`

export const OptionResultFill = styled.div<{ $percent: number }>`
  height: 100%;
  width: ${(props) => props.$percent}%;
  border-radius: 100px;
  background: ${SECONDARY_GREEN_07};
`

export const OptionResultsNote = styled.span`
  color: ${GRAY_SCALE_04};
  font-size: 12px;
  line-height: 16px;
`

export const InactiveBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${GRAY_SCALE_09};
  color: ${GRAY_SCALE_04};
  font-size: 11px;
  font-weight: 600;
`

export const LockedNotice = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 8px;
  background: ${SECONDARY_YELLOW_10};
  color: ${GRAY_SCALE_04};
  font-size: 13px;
  line-height: 18px;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const FieldLabelRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`

export const FieldLabel = styled.label`
  color: ${PRIMARY_BLUE_02};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`

export const FieldCounter = styled.span<{ $over?: boolean }>`
  color: ${(props) => (props.$over ? PRIMARY_RED_01 : GRAY_SCALE_04)};
  font-size: 12px;
  white-space: nowrap;
`

export const TextInput = styled.input<{ $error?: boolean }>`
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1px solid
    ${(props) => (props.$error ? PRIMARY_RED_01 : GRAY_SCALE_09)};
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: ${PRIMARY_BLUE_02};
  background: ${WHITE};

  &:focus {
    outline: none;
    border-color: ${(props) =>
      props.$error
        ? PRIMARY_RED_01
        : getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }

  &::placeholder {
    color: ${GRAY_SCALE_04};
  }

  &:disabled {
    background: ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
    color: ${GRAY_SCALE_04};
    cursor: not-allowed;
  }
`

export const FieldError = styled.span`
  display: block;
  color: ${PRIMARY_RED_01};
  font-size: 12px;
`

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const OptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const OptionIndex = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 100px;
  background: ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  color: ${GRAY_SCALE_04};
  font-size: 12px;
  font-weight: 600;
`

export const OptionField = styled.div`
  flex: 1;
  min-width: 0;
`

export const IconTextButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  min-width: 32px;
  padding: 0 8px;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 8px;
  background: ${WHITE};
  color: ${GRAY_SCALE_04};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: border-color 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    border-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
    color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const AddOptionButton = styled.button`
  align-self: flex-start;
  border: none;
  background: transparent;
  padding: 4px 0;
  color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const SettingsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px 24px;
`

export const ChoiceGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const ChoiceLabel = styled.label<{ $active?: boolean; $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border-radius: 100px;
  border: 1px solid
    ${(props) =>
      props.$active
        ? getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')
        : getDashColor('GRAY_SCALE_09', 'BEIGE')};
  background: ${(props) =>
    props.$active ? getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR') : WHITE};
  color: ${(props) => (props.$active ? WHITE : GRAY_SCALE_04)};
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }
`

export const SwitchLabel = styled.label<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: ${GRAY_SCALE_04};
  font-size: 13px;
  font-weight: 500;
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
  }
`

export const SwitchTrack = styled.span<{ $on?: boolean }>`
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 100px;
  background: ${(props) =>
    props.$on
      ? getDashColor('SECONDARY_GREEN_07', 'GRAY_DARK')
      : GRAY_SCALE_09};
  transition: background-color 0.15s ease;

  &:after {
    content: '';
    position: absolute;
    top: 3px;
    left: ${(props) => (props.$on ? '21px' : '3px')};
    width: 16px;
    height: 16px;
    border-radius: 100px;
    background: ${WHITE};
    transition: left 0.15s ease;
  }
`

export const FormActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 4px;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`

export const ContainerButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  @media (max-width: 1152px) {
    justify-content: center;
  }
`

export const ContainerCard = styled.div`
  flex: 1;
  min-width: 220px;
  max-width: 50%;
  @media (max-width: 1152px) {
    width: 100%;
    max-width: 100%;
  }
`

export const DetailCard = styled.div`
  display: flex;
  height: 85px;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 5px;
  padding: 0px 30px;
  margin-top: 8px;

  @media (max-width: 1152px) {
    width: 100%;
  }
`

export const LabelCard = styled.div`
  color: ${GRAY_SCALE_04};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 30px;
  align-content: center;
`

export const CardTitle = styled.div`
  color: ${PRIMARY_BLUE_02};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 19.6px;
  margin-top: 4px;
`

export const IconDetailContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  &:before {
    content: '';
    width: 42px;
    height: 42px;
    background-color: ${PRIMARY_RED_10};
    border-radius: 100px;
    position: absolute;
    z-index: 0;
  }
  & div {
    z-index: 1;
  }
  &.graph {
    &:before {
      background-color: ${SECONDARY_BLUE_10};
    }
  }
  &.answered {
    &:before {
      background-color: ${SECONDARY_GREEN_10};
    }
  }
  &.avg {
    &:before {
      background-color: ${SECONDARY_YELLOW_10};
    }
  }
`

export const ReviewsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
`

export const ReviewItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 5px;
  padding: 20px 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const ReviewContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
`

export const ReviewHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
`

export const ReviewClientName = styled.span`
  color: ${PRIMARY_BLUE_02};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const ReviewRating = styled.span`
  color: ${SECONDARY_YELLOW_05};
  font-size: 14px;
  font-weight: 600;
`

export const ReviewMeta = styled.span`
  color: ${GRAY_SCALE_04};
  font-size: 12px;
  font-weight: 400;
`

export const ReviewComment = styled.p`
  color: ${GRAY_SCALE_04};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  word-break: break-word;
`

export const ReviewLink = styled.a`
  color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const ModeratedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${PRIMARY_RED_10};
  color: ${PRIMARY_RED_01};
  font-size: 11px;
  font-weight: 600;
`

export const ApprovedBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  background: ${SECONDARY_GREEN_10};
  color: ${SECONDARY_GREEN_07};
  font-size: 11px;
  font-weight: 600;
`

export const ReviewActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
  }
`

export const EmptyState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
  color: ${GRAY_SCALE_04};
  font-size: 14px;
  border: 1px dashed ${GRAY_SCALE_09};
  border-radius: 8px;
  margin-top: 8px;
`

export const ExceptionContainer = styled.div<{ height?: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height ?? 200}px;
`

export const CloseButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const ModalContainerTop = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
`

export const ModalContainerBottom = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
`

export const ModalTitle = styled.h5`
  color: ${PRIMARY_BLUE_02};
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22.4px;
  margin-bottom: 8px;
`

export const ModalSubText = styled.p`
  color: ${GRAY_SCALE_04};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19.6px;
  margin: 0;
`

export const ReasonTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  margin-bottom: 24px;
  padding: 12px 14px;
  border: 1px solid ${GRAY_SCALE_09};
  border-radius: 8px;
  resize: vertical;
  font-size: 14px;
  font-family: inherit;
  color: ${PRIMARY_BLUE_02};
  background: ${WHITE};

  &:focus {
    outline: none;
    border-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }

  &::placeholder {
    color: ${GRAY_SCALE_04};
  }
`

export const ReasonError = styled.span`
  display: block;
  color: ${PRIMARY_RED_01};
  font-size: 12px;
  margin-top: -16px;
  margin-bottom: 16px;
`

export const ListToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
`

export const FilterGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const FilterChip = styled.button<{ $active?: boolean }>`
  border: 1px solid
    ${(props) =>
      props.$active
        ? getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')
        : getDashColor('GRAY_SCALE_09', 'BEIGE')};
  background: ${(props) =>
    props.$active
      ? getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')
      : WHITE};
  color: ${(props) => (props.$active ? WHITE : GRAY_SCALE_04)};
  border-radius: 100px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease;

  &:hover {
    border-color: ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
    color: ${(props) =>
      props.$active ? WHITE : getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
  }
`

export const SortGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SortLabel = styled.span`
  color: ${GRAY_SCALE_04};
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`

export const SortSelect = styled.select`
  height: 36px;
  min-width: 170px;
  padding: 0 12px;
  border: 1px solid ${getDashColor('GRAY_SCALE_09', 'BEIGE')};
  border-radius: 8px;
  background: ${WHITE};
  color: ${PRIMARY_BLUE_02};
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${getDashColor('GRAY_SCALE_05', 'GRAY_DARK')};
  }
`
